<template>
  <div v-loading="loading">
    <draggable
      group="columns"
      :list="products"
      v-bind="dragOptions"
      @start="drag = true"
      @end="drag = false"
    >
      <transition-group
        type="transition"
        :name="!drag ? 'flip-list' : null"
        class="columns-list"
      >
        <div
          v-for="(product, index) in products"
          :key="product.id"
          class="product-item"
        >
          <el-tag
            size="small"
            style="margin-right: 10px;"
          >
            {{ index + 1 }}.
          </el-tag><strong>#{{ product.id }}</strong> {{ product.name }}
          <el-button
            size="mini"
            style="float: right;"
            icon="el-icon-caret-bottom"
            @click="moveBottom(product.id)"
          >
            Lista végére
          </el-button>
          <el-button
            size="mini"
            style="float: right; margin-right: 10px;"
            icon="el-icon-caret-top"
            @click="moveTop(product.id)"
          >
            Lista elejére
          </el-button>
        </div>
      </transition-group>
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  components: {
    draggable
  },
  data() {
    return {
      drag: true,
      products: [],
      loading: [],
      dragOptions: {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      },
    };
  },
  async mounted() {
    await this.fetchProducts();
  },
  methods: {
    moveTop(id) {
      const selected = this.products.find(product => product.id === id);
      this.products = this.products.filter(product => product.id !== id);
      this.products.unshift(selected);
    },
    moveBottom(id) {
      const selected = this.products.find(product => product.id === id);
      this.products = this.products.filter(product => product.id !== id);
      this.products.push(selected);
    },
    async fetchProducts() {
      this.loading = true;
      try {
        this.products = await axios.get('api/products/order');
      } catch (e) {
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
  .product-item {
    list-style: none;
    padding: 13px;
    margin-bottom: -1px;
    border: 1px solid rgba(0, 0, 0, .125);
    cursor: move;
    background: #ffffff;
    line-height: 1.45;
    transition: 0.3s;

    &:hover {
      background: #F5F7FA;
      transition: 0.3s;
    }

    &:first-child {
      border-top-left-radius: .25rem;
      border-top-right-radius: .25rem;
    }

    &:last-child {
      border-bottom-right-radius: .25rem;
      border-bottom-left-radius: .25rem;
    }
  }
</style>
